import { render, staticRenderFns } from "./marathon.vue?vue&type=template&id=11fc014e&scoped=true&"
import script from "./marathon.vue?vue&type=script&lang=js&"
export * from "./marathon.vue?vue&type=script&lang=js&"
import style0 from "./marathon.vue?vue&type=style&index=0&id=11fc014e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc014e",
  null
  
)

export default component.exports